import { render, staticRenderFns } from "./pricePloy.vue?vue&type=template&id=df411342&scoped=true"
import script from "./pricePloy.vue?vue&type=script&lang=js"
export * from "./pricePloy.vue?vue&type=script&lang=js"
import style0 from "./pricePloy.vue?vue&type=style&index=0&id=df411342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df411342",
  null
  
)

export default component.exports